/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_File_Win_X86_Msi_TitleInputs */

const en_pc_dl_file_win_x86_msi_title = /** @type {(inputs: Pc_Dl_File_Win_X86_Msi_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installer (32-bit)`)
};

const zh_pc_dl_file_win_x86_msi_title = /** @type {(inputs: Pc_Dl_File_Win_X86_Msi_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安装程序（32 位）`)
};

/**
* | output |
* | --- |
* | "Installer (32-bit)" |
*
* @param {Pc_Dl_File_Win_X86_Msi_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_file_win_x86_msi_title = /** @type {((inputs?: Pc_Dl_File_Win_X86_Msi_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_File_Win_X86_Msi_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_file_win_x86_msi_title(inputs)
	return zh_pc_dl_file_win_x86_msi_title(inputs)
});
export { pc_dl_file_win_x86_msi_title as "pc.dl.file.win_x86_msi.title" }